import { Component, OnInit } from '@angular/core';
import { ContainerScreenHandler } from 'src/app/handlers/ContainerScreenHandler';
import screen from '../../../../assets/ContainerScreen.json'


@Component({
  selector: 'app-container-list',
  templateUrl: './container-list.component.html',
  styleUrls: ['./container-list.component.scss']
})
export class ContainerListComponent implements OnInit {

  public screenStructure = JSON.parse(JSON.stringify(screen));

  constructor(public screenHandler: ContainerScreenHandler) { }

  ngOnInit() {
  }

}
